import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductCost, ProductCostCurrency, ProductCostKind, ProductCostPayload } from './product-costs.model';
import { Result } from '@/reservation/reservation.model';
import { Product } from '../product.model';

@Injectable({
	providedIn: 'root',
})
export class ProductCostsApiService {
	private readonly apiUrl = environment.apiUrl;
	private readonly httpClient = inject(HttpClient);

	getProductCosts(productId: number): Observable<ProductCost[]> {
		return this.httpClient.get<ProductCost[]>(`${this.apiUrl}/product/cost/`, {
			params: { product: productId },
		});
	}

	createProductCost(payload: ProductCostPayload): Observable<ProductCost> {
		return this.httpClient.post<ProductCost>(`${this.apiUrl}/product/cost/`, payload);
	}

	updateProductCost(costId: number, payload: ProductCostPayload): Observable<ProductCost> {
		return this.httpClient.put<ProductCost>(`${this.apiUrl}/product/cost/${costId}/`, payload);
	}

	getProductCost(costId: number): Observable<ProductCost> {
		return this.httpClient.get<ProductCost>(`${this.apiUrl}/product/cost/${costId}/`);
	}

	patchProductCost(costId: number, payload: Partial<ProductCost>): Observable<ProductCost> {
		return this.httpClient.patch<ProductCost>(`${this.apiUrl}/product/cost/${costId}/`, payload);
	}

	getCurrencies(): Observable<ProductCostCurrency[]> {
		return this.httpClient
			.get<Result<ProductCostCurrency>>(`${this.apiUrl}/currency/`)
			.pipe(map((result) => result.results ?? []));
	}

	getCostKinds(): Observable<ProductCostKind[]> {
		return this.httpClient
			.get<Result<ProductCostKind>>(`${this.apiUrl}/product/cost_kind/`)
			.pipe(map((result) => result.results ?? []));
	}

	patchProductCosts(productId: number, payload: { costs: number[] }): Observable<Product> {
		return this.httpClient.patch<Product>(`${this.apiUrl}/product/${productId}/`, payload);
	}
}
